export default (contactsCSV) => {
  const arr = [];
  for (let i = 1; i < contactsCSV.length; i += 1) {
    const row = {};
    for (let j = 0; j < contactsCSV[i].length; j += 1) {
      row[contactsCSV[0][j]] = contactsCSV[i][j];
    }
    // Handles CSVs with extra empty row
    if (Object.values(row).some(v => v !== '')) {
      arr.push(row);
    }
  }
  return arr;
};
